"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInfo = getInfo;
exports.login = login;
exports.logout = logout;
exports.ssoLogin = ssoLogin;
exports.wxWorkLogin = wxWorkLogin;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function login(data) {
  return (0, _requestAuth.default)({
    url: '/login',
    method: 'post',
    data: data
  });
}
function getInfo() {
  return (0, _requestAuth.default)({
    url: '/sysUser/currentInfo',
    method: 'get'
  });
}
function logout() {
  return (0, _requestAuth.default)({
    url: '/sysLogout',
    method: 'get'
  });
}
function wxWorkLogin(data) {
  return (0, _requestAuth.default)({
    url: '/wxWorkLogin',
    method: 'post',
    data: data
  });
}
function ssoLogin(data) {
  return (0, _requestAuth.default)({
    url: '/ssoLogin',
    method: 'post',
    data: data
  });
}